<lib-renderer-container
  [params]="params"
  [showTooltip]="false"
>
  {{ params.value?.value | date: 'dd.MM.yyyy' }}
</lib-renderer-container>
